import React, { useEffect, useState } from "react";
import './style.css'

export const Banner = ({ image, text }) => {
  const [offsetY, setOffsetY] = useState(0);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  
  }, []);

  return (
    <div id="background" className="BannerProjects ">
      <img
        src={image}
        className="BannerProjects_Image"
        alt="banner_image"
        style={{ transform: `translateY(${offsetY * 0.5}px)` }}
      />

      <div className="BannerProjects_Title Container">{text}</div>
    </div>
  );
};
